<template>
  <div class="df fdc container">
    <div class="df aic jcb header">
      <div class="title">物料平衡监控大屏</div>
      <div class="filter-box">
        <div class="filter-item">
          <span class="filter-label">生产线:</span>
          <el-select
            v-model="value"
            placeholder="请选择"
            size="small"
            @change="changeProduction"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-label">日期:</span>
          <el-date-picker
            size="small"
            v-model="timeValue1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="changeDate"
          >
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="main-content df fdr">
      <div
        class="material-overview df fdc scroll-box"
        style="height: 100%; gap: 10px; overflow-y: auto"
      >
        <div class="card" style="">
          <div class="card-title">
            <span class="special-title">物料总览</span>
            <div style="cursor: pointer">
              <i
                @click="openConfigEdit"
                class="el-icon-s-tools"
                style="font-size: 30px; color: #fff"
              ></i>
            </div>
          </div>
          <div class="card-content scroll-box" v-loading="rateLoading">
            <template v-if="!rateLoading">
              <div class="stats-container">
                <div class="stat-item">
                  <div class="stat-label">总投入</div>
                  <div class="stat-value">
                    {{ totalInvestment
                    }}<span style="font-size: 16px"> kg</span>
                  </div>
                </div>
                <div class="stat-item">
                  <div class="stat-label">总产出</div>
                  <div class="stat-value">
                    {{ totalOutput }}<span style="font-size: 16px"> kg</span>
                  </div>
                </div>
                <div class="stat-item">
                  <div class="stat-label">总损耗</div>
                  <div class="stat-value">
                    {{ totalLoss }}<span style="font-size: 16px"> kg</span>
                  </div>
                </div>
                <div class="stat-item">
                  <div class="stat-label">综合损耗率</div>
                  <div class="stat-value">{{ lossRate }}%</div>
                </div>
              </div>
              <div
                style="
                  margin-top: 20px;
                  background: linear-gradient(135deg, #1e2a47 0%, #222c47 100%);
                  border-radius: 8px;
                  padding: 15px;
                  border: 1px solid #2a3a5a;
                "
              >
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 10px;
                  "
                >
                  <span style="color: #8f9bba">理论目标得率</span>
                  <span style="color: #36c17c; font-weight: bold"
                    >{{ theoreticalOutputRate }}%</span
                  >
                </div>
                <div
                  style="
                    height: 10px;
                    background-color: #2a3a5a;
                    border-radius: 5px;
                    overflow: hidden;
                  "
                >
                  <div
                    :style="`
                    height: 100%;
                    width: ${theoreticalOutputRate}%;
                    background: linear-gradient(90deg, #36c17c, #4cd89a);
                    border-radius: 5px;
                  `"
                  ></div>
                </div>
              </div>
              <div
                style="
                  margin-top: 20px;
                  background: linear-gradient(135deg, #1e2a47 0%, #222c47 100%);
                  border-radius: 8px;
                  padding: 15px;
                  border: 1px solid #2a3a5a;
                "
              >
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 10px;
                  "
                >
                  <span style="color: #8f9bba">实际目标达成率</span>
                  <span style="color: #36c17c; font-weight: bold"
                    >{{ balanceRate }}%</span
                  >
                </div>
                <div
                  style="
                    height: 10px;
                    background-color: #2a3a5a;
                    border-radius: 5px;
                    overflow: hidden;
                  "
                >
                  <div
                    :style="`
                    height: 100%;
                    width: ${balanceRate}%;
                    background: linear-gradient(90deg, #36c17c, #4cd89a);
                    border-radius: 5px;
                  `"
                  ></div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="card" style="height: 600px">
          <div class="card-title">
            <span class="special-title">消耗排行</span>
          </div>
          <div
            class="card-content scroll-box table1 df fdc"
            v-loading="charts2Loading"
          >
            <template v-if="!charts2Loading && lossData.length">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="table-header"
              >
                <tbody>
                  <tr>
                    <td width="20%">
                      <span>排行</span>
                    </td>
                    <td width="40%">
                      <span>批次</span>
                    </td>
                    <td width="40%">
                      <span>损耗量</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="tableC" v-if="!charts2Loading">
                <vue-seamless-scroll
                  :data="lossData"
                  class="seamless-warp"
                  :class-option="optionSetting"
                >
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    class="item"
                  >
                    <tbody>
                      <tr v-for="(item, index) in lossData" :key="index">
                        <td width="20%">
                          <span style="color: #7e6dfb">{{ index + 1 }}</span>
                        </td>
                        <td width="40%">
                          <span style="color: #6c9bcf">{{ item.name }}</span>
                        </td>
                        <td width="40%">
                          <span style="color: #ffcc66">{{ item.data }}kg</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </vue-seamless-scroll>
              </div>
            </template>
            <el-empty
              description="无相关数据"
              v-else-if="!charts2Loading && !lossData.length"
            ></el-empty>
          </div>
        </div>
      </div>
      <!-- <div class="card material-overview pulse">
        <div class="card-title">
          <span class="special-title">损耗排行</span>
        </div>
        <div
          class="card-content scroll-box"
          style="height: 300px"
          v-loading="rateLoading"
        ></div>
      </div> -->
      <div class="card production-flow pulse">
        <div class="card-title">
          <span class="special-title">生产流程与物料平衡</span>
          <div style="display: flex; gap: 10px"></div>
        </div>
        <div class="card-content">
          <div class="flow-container" id="processFlow" v-loading="stepLoading">
            <Step
              :stepsData="stepData"
              v-if="!stepLoading"
              :productionLineId="value"
              @update="getStep"
            />
          </div>
        </div>
      </div>

      <!-- 右侧图表 -->
      <div class="charts-container df fdc">
        <!-- 成品产出统计 -->
        <div class="card chart-box pulse">
          <div class="card-title">
            <span class="special-title">异常批次列表</span>
          </div>
          <template v-if="listData.length">
            <div
              class="card-content pulse table"
              style="overflow: hidden"
              v-loading="abnormalListLoading"
            >
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="table-header"
              >
                <tbody>
                  <tr>
                    <td width="10%">
                      <span>批次</span>
                    </td>
                    <td width="20%">
                      <span>类型</span>
                    </td>
                    <td width="20%">
                      <span>理论值</span>
                    </td>
                    <td width="20%">
                      <span>实际值</span>
                    </td>
                    <td width="30%">
                      <span>创建时间</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div style="overflow-hidden" v-if="!abnormalListLoading">
                <vue-seamless-scroll
                  :data="listData"
                  class="seamless-warp"
                  :class-option="optionSetting"
                >
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    class="item"
                  >
                    <tbody>
                      <tr v-for="(item, index) in listData" :key="index">
                        <td width="10%">
                          <span :style="{ color: '#6c9bcf' }">{{
                            item.name
                          }}</span>
                        </td>
                        <td width="20%">
                          <span
                            :style="
                              item.type ? 'color:#ff7c7c' : 'color:#ffcc66'
                            "
                            >{{ item.type ? "损耗异常" : "平衡异常" }}</span
                          >
                        </td>
                        <td width="20%">
                          <span :style="{ color: '#5cd0a0' }"
                            >{{ item.theory }}%</span
                          >
                        </td>
                        <td width="20%">
                          <span :style="{ color: '#7e6dfb' }"
                            >{{ item.actual }}%</span
                          >
                        </td>
                        <td width="30%">
                          <span :style="{ color: '#a0a0b0' }">{{
                            item.createTime
                          }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </vue-seamless-scroll>
              </div>
            </div>
          </template>
          <el-empty
            :style="{
              height: '100%',
              borderRadius: '8px',
              overflow: 'hidden',
            }"
            description="无相关数据"
            v-else
            v-loading="abnormalListLoading"
          ></el-empty>
        </div>

        <!-- 损耗分析 -->
        <div class="card chart-box">
          <div class="card-title">
            <span class="special-title">损耗分析</span>
          </div>
          <div
            class="card-content"
            :style="{
              overflow: 'hidden',
            }"
            v-loading="charts2Loading"
          >
            <Charts2
              class="chart"
              :dataList="lossData"
              v-if="!charts2Loading && lossData.length > 0"
            />
            <el-empty
              description="无相关数据"
              v-else-if="!charts2Loading && !lossData.length"
            ></el-empty>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="设置" :visible.sync="showConfigEdit" width="30%">
      <el-form ref="form" label-width="120px" label-position="left">
        <el-form-item label="理论目标得率">
          <el-input
            placeholder="请输入理论目标得率"
            v-model="dataInfo"
            type="number"
            clearable
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showConfigEdit = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/util/extra-api";
import { local } from "@/util/util";
import axios from "@/util/api";
// import Charts1 from "./components/charts1.vue";
import Charts2 from "./components/charts2.vue";
import Step from "./components/step.vue";

export default {
  data() {
    return {
      companyId: "",
      timeValue1: [],
      options: [],
      value: "",
      stepData: [],
      stepLoading: true,
      rateLoading: true,
      charts2Loading: true,
      balanceRate: null,
      lossRate: null,
      totalInvestment: null,
      totalLoss: null,
      totalOutput: null,
      lossData: [],
      optionSetting: {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      },
      listData: [],
      abnormalListLoading: false,
      showConfigEdit: false,
      dataInfo: "",
      theoreticalOutputRate: 0,
    };
  },
  methods: {
    handleAdd() {
      api
        .post("/v1/wx/companyMaterial/addSourceInfo", {
          name: "理论平衡率",
          type: 7,
          source: 0,
          sourceId: 0,
          otherId: 0,
          dataInfo: this.dataInfo,
          companyId: this.companyId,
          theoretical: null,
          goodsId: null,
          goodsName: "",
          batchNumber: "",
          isTotal: false,
          productionLineId: this.value,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: "新增成功",
              type: "success",
            });
            this.showConfigEdit = false;
            this.changeDate();
          }
        });
    },
    openConfigEdit() {
      this.dataInfo = this.theoreticalOutputRate;

      this.showConfigEdit = true;
    },
    abnormalList() {
      this.abnormalListLoading = true;
      api
        .get("/v1/wx/companyMaterial/abnormalList", {
          companyId: this.companyId,
          startTime: this.timeValue1 ? this.timeValue1[0] : "",
          endTime: this.timeValue1 ? this.timeValue1[1] : "",
          productionLineId: this.value,
          finishedTag: "",
        })
        .then((res) => {
          if (res.code === 200) {
            this.listData = res.data;
            this.abnormalListLoading = false;
          }
        });
    },
    getLossData() {
      this.charts2Loading = true;
      api
        .get("/v1/wx/companyMaterial/lossData", {
          companyId: this.companyId,
          startTime: this.timeValue1 ? this.timeValue1[0] : "",
          endTime: this.timeValue1 ? this.timeValue1[1] : "",
          productionLineId: this.value,
          finishedTag: "",
        })
        .then((res) => {
          if (res.code === 200) {
            // console.log(res.data, "损耗分析数据");
            this.lossData = res.data;
            this.charts2Loading = false;
          }
        });
    },
    changeDate() {
      this.getOverview();
      this.getStep();
      this.getLossData();
      this.abnormalList();
    },
    getOverview() {
      this.rateLoading = true;
      api
        .get("/v1/wx/companyMaterial/overview", {
          companyId: this.companyId,
          startTime: this.timeValue1 ? this.timeValue1[0] : "",
          endTime: this.timeValue1 ? this.timeValue1[1] : "",
          productionLineId: this.value,
          finishedTag: "",
        })
        .then((res) => {
          if (res.code === 200) {
            this.rateLoading = false;
            // console.log(res.data, "结果");
            [
              "theoreticalOutputRate",
              "totalInvestment",
              "totalLoss",
              "totalOutput",
              "balanceRate",
              "lossRate",
            ].forEach((v) => {
              this[v] = res.data[v];
            });
          }
        });
    },
    changeProduction(value) {
      // console.log(value);
      this.getStep();
      this.getLossData();
      this.getOverview();
      this.abnormalList();
    },
    getBaseInfo() {
      // /v1/wx/companyMaterial/getBaseInfo
      api
        .get("/v1/wx/companyMaterial/getBaseInfo", {
          companyId: this.companyId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.options = res.data.map((v) => {
              return {
                label: v.name,
                value: v.id,
              };
            });
            this.value = res.data[0].id;
            this.getStep();
            this.getOverview();
            this.getLossData();
            this.abnormalList();
          }
        });
    },
    getStep() {
      this.stepLoading = true;
      api
        .get("/v1/wx/companyMaterial/getStep", {
          companyId: this.companyId,
          productionLineId: this.value,
          startTime: this.timeValue1 ? this.timeValue1[0] : "",
          endTime: this.timeValue1 ? this.timeValue1[1] : "",
          date: "",
        })
        .then((res) => {
          if (res.code === 200) {
            this.stepData = res.data;
            this.stepLoading = false;
          }
        })
        .catch((err) => {
          this.stepLoading = false;
        });
    },
  },
  mounted() {
    this.companyId = Number(localStorage.getItem("company_id"));
    this.getBaseInfo();
  },
  components: {
    // Charts1,
    Charts2,
    Step,
  },
  computed: {},
};
</script>

<style lang="scss" scoped >
.fdc {
  flex-direction: column;
}
.fdr {
  flex-direction: row;
}

.container {
  width: 100%;
  height: 100%;
  padding: 15px;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #0f1016;
  gap: 15px;
}

.header {
  height: 100px;
  background: linear-gradient(90deg, #13141b 0%, #1c1e2a 100%);
  border-radius: 10px;
  padding: 0 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  border: 1px solid #2a2c3d;
}

.title {
  flex: 1;
  width: 0;
  text-align: left;
  font-size: 36px;
  font-weight: bold;
  background: linear-gradient(90deg, #4d9eff 0%, #a2c6ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 0 10px rgba(77, 158, 255, 0.3);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.filter-box {
  background-color: rgba(0, 129, 255, 0.15);
  border: 1px solid #0081ff;
  border-radius: 8px;
  height: 60px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 20px;
  /deep/ .el-date-editor--datetimerange {
    background-color: #16243a !important;
  }
  /deep/ .el-range-input {
    background-color: #16243a !important;
    color: #fff;
  }
  /deep/.el-range-separator {
    color: #fff;
  }
  /deep/.el-input__inner {
    background-color: #16243a !important;
    color: #fff;
  }
  /deep/ .el-select-dropdown__wrap {
    max-height: 400px;
    overflow-y: scroll;
  }

  /deep/ .el-select-dropdown__wrap::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 8px;
    height: 8px;
  }

  /deep/ .el-select-dropdown__wrap::-webkit-scrollbar-thumb {
    border-radius: 5px;
    // background: rgba(255, 255, 255, 0.8);
    background: #bbb;
    transition: color 0.2s ease;
    cursor: pointer;
  }
}
.scroll-box::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
  height: 8px;
}

.scroll-box::-webkit-scrollbar-thumb {
  border-radius: 5px;
  // background: rgba(255, 255, 255, 0.8);
  background: #bbb;
  transition: color 0.2s ease;
  cursor: pointer;
}
.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  font-size: 14px;
  color: #8f9bba;
}

.filter-select {
  background-color: rgba(20, 30, 48, 0.6);
  border: 1px solid #2f456e;
  border-radius: 4px;
  color: #e1e1e1;
  padding: 5px 10px;
  width: 140px;
}

.filter-date {
  background-color: rgba(20, 30, 48, 0.6);
  border: 1px solid #2f456e;
  border-radius: 4px;
  color: #e1e1e1;
  padding: 5px 10px;
  width: 180px;
}

.filter-button {
  background-color: #0081ff;
  border: none;
  border-radius: 4px;
  color: white;
  padding: 6px 15px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.filter-button:hover {
  background-color: #0066cc;
}
.main-content {
  flex: 1;
  height: 0;
  gap: 20px;
}
.card {
  background-color: #1a1b29;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border: 1px solid #2a2c3d;
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-title {
  font-size: 18px;
  color: #8f9bba;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-content {
  flex: 1;
  height: 0;
  border-radius: 8px;
  overflow: auto;
}

/* 左侧物料总览 */
.material-overview {
  width: 320px;
}

// .stats-container {
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 15px;
// }

.stat-item {
  background: linear-gradient(135deg, #1e2a47 0%, #222c47 100%);
  border-radius: 8px;
  padding: 15px;
  border: 1px solid #2a3a5a;
  margin-bottom: 10px;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  margin: 10px 0;
  color: #e1e1e1;
}

.stat-label {
  font-size: 14px;
  color: #8f9bba;
}

.stat-trend {
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.trend-up {
  color: #36c17c;
}

.trend-down {
  color: #e9595d;
}

/* 中间生产流程 */
.production-flow {
  flex: 1;
  width: 0;
}

.flow-container {
  width: 100%;
  height: 100%;
  background-color: #151721;
  border-radius: 8px;
  overflow-y: auto;
  position: relative;
}

/* 右侧图表区域 */
.charts-container {
  width: 600px;
  gap: 20px;
}

.chart-box {
  flex: 1;
  height: 0;
}

.chart {
  width: 100%;
  height: 100%;
}

/* 工序节点样式 */
.process-node {
  fill: #252938;
  stroke: #0081ff;
  stroke-width: 2;
  rx: 5;
  ry: 5;
}

.process-text {
  fill: #e1e1e1;
  font-size: 12px;
  text-anchor: middle;
}

.process-value {
  fill: #8f9bba;
  font-size: 11px;
  text-anchor: middle;
}
/* 响应式调整 */
@media (max-width: 1920px) {
  .title {
    font-size: 32px;
  }
  .material-overview {
    width: 280px;
  }
  .charts-container {
    width: 520px;
  }
}

.special-title {
  position: relative;
  display: inline-block;
  padding: 0 10px 5px 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
}

.special-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, currentColor, transparent);
  border-radius: 2px;
}

/* 动画效果 */
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(1);
  }
}

.stat-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 129, 255, 0.2);
}
%table-style {
  width: 100%;
  height: 35px;
  table-layout: fixed;
  tr {
    td {
      padding: 10px 5px;
      text-align: center;
      background-color: transparent;
      white-space: nowrap;
      overflow: hidden;
      color: #e2e5ff;
      font-size: 16px;
    }
  }
}
.table1 {
  .table-header {
    @extend %table-style;
  }
  .tableC {
    flex: 1;
    height: 0;
  }
  .seamless-warp {
    height: 100%;
    overflow: hidden;
    visibility: visible;
    .colorRed {
      color: #ff4669;
    }
    .colorGreen {
      color: #45b97c;
    }
    .item {
      height: auto;
      @extend %table-style;
      tr {
        td {
          &.title {
            text-overflow: ellipsis;
            display: inline-block;
          }
        }
      }
    }
  }
}
.table {
  .table-header {
    @extend %table-style;
  }
  .seamless-warp {
    height: 400px;
    overflow: hidden;
    visibility: visible;
    .colorRed {
      color: #ff4669;
    }
    .colorGreen {
      color: #45b97c;
    }
    .item {
      height: auto;
      @extend %table-style;
      tr {
        td {
          &.title {
            text-overflow: ellipsis;
            display: inline-block;
          }
        }
      }
    }
  }
}

/deep/.el-form-item__content {
  width: calc(100% - 120px) !important;
}
</style>